import { FC, PropsWithChildren, DetailedHTMLProps, InputHTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './index.less';


export type CheckboxProps = Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'type'>

const Checkbox: FC<PropsWithChildren<CheckboxProps>> = ({
  checked,
  children,
  style,
  className,
  disabled,
  ...rest
}) => {
  const mainClassName = classNames(styles.main, {
    [styles.checked]: checked,
    [styles.disabled]: disabled
  })
  const renderCheckbox = () =>
    <span className={classNames(mainClassName, children ? undefined : className)} style={style}>
      <input
        checked={checked}
        disabled={disabled}
        type='checkbox'
        className={styles.input}
        {...rest}
      />
      <span className={styles.inner} />
    </span>

  if (children) {
    return (
      <label className={classNames(styles.wrapper, className)} style={style}>
        {renderCheckbox()}
        {children}
      </label>
    )
  }
  return renderCheckbox();
}

export default Checkbox;
